<template>

<div id="metro-passenger-information">
  <h4 v-if="list"><b-icon icon="card-list"></b-icon><span>Aktiiviset tiedotteet</span></h4>
  <h4 v-if="update"><b-icon icon="pencil-square"></b-icon><span >Muokkaa tiedotetta</span><b-icon icon="x-lg" class='close-btn' @click="showInfoList"></b-icon></h4>
  <h4 v-if="template"><b-icon icon="file-earmark-plus"></b-icon><span >Valitse tiedotepohja</span><b-icon icon="x-lg" class='close-btn' @click="showInfoList"></b-icon></h4>
  <h4 v-if="create"><b-icon icon="pencil-square"></b-icon><span >Luo uusi tiedote</span><b-icon icon="x-lg" class='close-btn' @click="showInfoList"></b-icon></h4>


 <transition name="fade" mode="out-in">
     
   
  
  <div v-if="list" key="list">
    <!--h4><b-icon icon="info-circle"></b-icon><span >Voimassa olevat ja tulevat tiedotteet</span></h4-->
    <div v-for="info in validInfos" :key="info.id" class='info-text' :class="'template-' + info.template + ' priority-' + info.priority" @click="updateInfo(info.id)">
      
      <div class='status'>
        
        <div v-if="!info.priority || info.priority == 'normal'" class='priority normal'>Tiedote</div>
        <div v-if="info.priority == 'high'" class='priority high'>Kriisi</div>

        <div class="targets">
          <div class="displays">Laiturinäytöt</div> <div>OMM</div> 
        </div>
        


        <!--div class='template' :class="'template-' + info.template"><div>{{ info.templateName }} </div></div-->
      
        <div class='i-validity'>
        <div class='icon'>
          <b-icon v-if="info.state==1" icon="check-square-fill" class='valid' title="Voimassa"></b-icon>
          <b-icon v-if="info.state==2" icon="dash-square-fill" class='upcoming' title="Tulossa"></b-icon>
          <b-icon v-if="!info.state" icon="question-square-fill" ></b-icon>
        </div>

        <div class="validity">
          <span v-if="info.state==1" class='time'>10:20 - 12:20</span>
          <span v-if="info.state==2" class='time'>14:30 - 18:30</span>
        </div>
        </div>
        <!--div class="validity">
          <div><span class='date'>{{ getValidityStartDate(info) }}</span><span class='time'>10:20</span></div>
          <div><span class='date'>{{ getValidityStartDate(info) }}</span><span class='time'>12:20</span></div>          
        </div-->
        
        <!--div class='template' :class="'template-' + info.template"><div>{{ info.templateName }} </div></div-->
      </div>
      
      <div class='texts'>
        <div class='template' :class="'template-' + info.template"><div>{{ info.templateName }} </div></div>
        <div class="fi"><div class='flag'><img src="/traveller-ui/static/img/flags/FI.png"></div><div>{{ info.fi }}</div></div>
        <div class="se"><div class='flag'><img src="/traveller-ui/static/img/flags/SE.png"></div><div>{{ info.se }}</div></div>
        <div class="en"><div class='flag'><img src="/traveller-ui/static/img/flags/GB.png"></div><div>{{ info.en }}</div></div>
       
      </div>     
    </div>

    <div>
      <a href="#" class='link'><b-icon icon="chevron-down"></b-icon>Näytä aiemmat</a>
      <t-button type="add" @click="createInfo" style='float:right'>Lisää uusi</t-button>       
    </div>

    <!--div>
      <t-button type="add" @click="createInfo">Luo uusi tiedote</t-button>       
      <a href="#" style='float:right; margin-top: 5px'><b-icon icon="chevron-down" style='margin-right: 8px;'></b-icon>Näytä aiemmat</a>
    </div-->

  </div>
  
  <div v-if="template" key="template">
     <PassengerInformationTemplates @select="templateSelected"/>
  </div>

  <div v-if="create" key="create">
    <PassengerInformationEditor type="create" :stations=stations @close="showInfoList" @save="saveInfo" />
  </div>

  <div v-if="update" key="update">
    <PassengerInformationEditor type="update" :item="selectedInfo" :stations=stations @close="showInfoList" @save="saveInfo" @remove="removeInfo" />
  </div>

  </transition>

</div>

</template>



<script>

import moment from "moment";

import PassengerInformationEditor from '@/components/Metro/PassengerInformationEditor.vue'
import PassengerInformationTemplates from "./PassengerInformationTemplates.vue";

export default ({
  props: ['stations'],
  components: {
        PassengerInformationEditor, PassengerInformationTemplates
  }, 
    data: function() {
        return {
            validInfos: [
                { id: 1, 
                  fi: "Metroliikenne on keskeytetty toistaiseksi kokonaan. Älkää nousko juniin. Katsokaa lisätietoa hsl.fi", 
                  se: "Det är tillsvidare stopp i metrotrafiken. Stig inte på tåget. För tilläggsinformation se HSL.fi.",  
                  en: "Metro services are suspended until further notice. Do not board the trains. For more information, see HSL.fi.",
                  state: 1,
                  start: "25.11.2025 10:20",
                  end: "26.11.2025 18:20",
                  template: 1,
                  templateName: "Totaalikatko",
                  priority: 'high',
                  targets: ["Laiturinäytöt", "OMM"]                   
                },
                /*
                { id: 2, 
                  fi: "Hyvää joulua!", 
                  se: "God jul!",  
                  en: "Merry Christmas!",
                  state: 1,
                  template: 0,
                  templateName: "Vapaa teksti"          
                },
                */
                { id: 3, 
                  fi: "Metroliikenteessä on häiriöitä. Lisätietoa hetken kuluttua.", 
                  se: "Det finns störningar i metrotrafiken. Mer information om en stund.",  
                  en: "There are disruptions in the metro service. More information soon.",
                  state: 1,
                  template: 4,
                  templateName: "Osittainen liikenne lännestä"         
                },
                { id: 4, 
                  fi: "Siilitien metroaseman toinen hissi on epäkunnossa", 
                  se: "Den andra hissen på Igelkottsvägen metrostation är ur funktion.",  
                  en: "The second elevator at Siilitie metro station is out of order.",
                  state: 2,
                  template: "02",
                  templateName: "Vapaa teksti"          
                },
                /*
                { id: 5, 
                  fi: "Metroa liikennöidään poikkeuksellisesti harvennetulla vuorovälillä.", 
                  se: "Metron kör undantagsvis med glesare tidtabell.",  
                  en: "The metro is operating a reduced service.",
                  state: 2,
                  template: 6,
                  templateName: "Muut häiriötapaukset"       
                }
                */
            ],
            selectedInfo: null,
            list: true,
            template: false,
            create: false,
            update: false,
            slideTest: false


        }
    },
    methods: {
      getValidityStartDate(info){
        let aika = moment();
        if(info.state == 2)
          aika.add(1, 'days');

        return aika.format("D.M.YYYY");
      },
      showInfoList(){
        this.list = true;
        this.template = this.create = this.update = false;
        this.$emit('listMode');
      },
      createInfo(){
        this.create = true;
        this.list = this.template = this.update = false;
        this.$emit('editorMode');
      },
      updateInfo(id){
        this.selectedInfo = this.validInfos.find(info => info.id == id);
        this.update = true;
        this.list = this.template = this.create = false;
         this.$emit('editorMode');
       
      },
      selectTemplate(){
        this.template = true;
        this.list = this.create = this.update = false;
        
      },
      templateSelected(template){
        this.selectedInfo = template;
        this.create = true;
        this.list = this.template = this.update = false;
      },
      saveInfo(item){
        let info  = this.validInfos.find(info => info.id == item.id);
        if(info){
          info.fi = item.fi;
        }
        else {
          this.validInfos.push(item);       
          
          console.log(item.template);
        }
        
      },
      removeInfo(item){
        this.validInfos = this.validInfos.filter(info => info.id != item.id);
        this.showInfoList();
      }
     ,
     slide(){
        this.slideTest = !this.slideTest;
     }
    },
    
})
</script>
